/**
 * 导出提示弹窗
 * 对齐 web后台.html ExportModal — 点击"导出"后弹出，提示用户去下载管理页查看进度。
 *
 * 与旧 ExportButton 的差异：
 *  - 不再前端轮询进度 / 不再自动下载
 *  - 导出任务在后端异步生成，用户主动到下载管理页下载
 */
import React from 'react'
import { Button } from 'antd'
import { CloseOutlined, DownloadOutlined } from '@ant-design/icons'

interface ExportModalProps {
  visible: boolean
  onClose: () => void
  /** 跳转到下载管理页 — 由调用方注入（避免硬编码路由） */
  onGoToDownloads?: () => void
}

const ExportModal: React.FC<ExportModalProps> = ({
  visible,
  onClose,
  onGoToDownloads
}) => {
  if (!visible) return null

  return (
    <div
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose()
      }}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9000,
        display: 'grid',
        placeItems: 'center',
        background: 'rgba(15,23,42,.32)'
      }}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: 14,
          padding: '32px 36px 28px',
          width: 460,
          boxShadow: '0 20px 60px rgba(0,0,0,.18)',
          position: 'relative'
        }}
      >
        <span
          onClick={onClose}
          style={{
            position: 'absolute',
            top: 16,
            right: 16,
            cursor: 'pointer',
            color: '#9CA3AF',
            padding: 4,
            lineHeight: 1
          }}
        >
          <CloseOutlined />
        </span>

        <h2
          style={{
            margin: '0 0 20px',
            fontSize: 17,
            fontWeight: 600,
            color: '#1F2937',
            display: 'flex',
            alignItems: 'center',
            gap: 8
          }}
        >
          <DownloadOutlined style={{ color: '#3B7DEB' }} /> 导出文件
        </h2>

        <div
          style={{
            fontSize: 14,
            color: '#4B5563',
            lineHeight: 1.7,
            marginBottom: 24
          }}
        >
          文件生成中，请到{' '}
          <a
            onClick={() => {
              onClose()
              onGoToDownloads && onGoToDownloads()
            }}
            style={{ color: '#3B7DEB', fontWeight: 500 }}
          >
            下载管理
          </a>{' '}
          中去查看生成好的文件。
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button onClick={onClose}>关闭</Button>
        </div>
      </div>
    </div>
  )
}

export default ExportModal
